import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  Document,
  DocumentCaptureRequest
} from '../../models/document-capture';

@Injectable({
  providedIn: 'root'
})
export class DocumentCaptureHttpService {
  private baseUrl = '';
  private versionId = '';

  constructor(private http: HttpClient) {}

  init({ baseUrl, versionId }: { baseUrl: string; versionId?: string }) {
    this.baseUrl = baseUrl;
    this.versionId = versionId;
  }

  getDocuments(token: string) {
    this.assertNotEmpty(this.baseUrl);
    const url = `${this.baseUrl}/documents`;
    const headers = this.buildHeaders(token);
    return this.http
      .get<Document>(url, headers)
      .pipe(
        catchError((response: HttpErrorResponse) =>
          throwError({
            ...response,
            error: response.error && response.error.data
          })
        )
      );
  }

  updateDNI(token: string, body: DocumentCaptureRequest) {
    this.assertNotEmpty(this.baseUrl);
    const url = `${this.baseUrl}/documents`;
    const headers = this.buildHeaders(token);
    return this.http
      .post<void>(url, body, headers)
      .pipe(
        catchError((response: HttpErrorResponse) =>
          throwError({
            ...response,
            error: response.error && response.error.data
          })
        )
      );
  }

  private assertNotEmpty(input) {
    if (!input) {
      throw new Error('Base url empty, initialization is required');
    }
  }

  private buildHeaders(token: string) {
    const headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('X-Authorization', `Bearer ${token}`);

    if (this.versionId) {
      headers.append('X-Version-Id', this.versionId);
    }

    return { headers };
  }
}
